export default class Retainer {
    constructor () {

        this.id = null
        this.client_id = null
        this.amount = 0
        this.start = ""
        this.end = ""
    }
}
